var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('p',{staticClass:"mb-0 darkBluishGray--text caption font-weight-medium"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_c('p',{staticClass:"body-2 font-weight-bold primary--text"},[_vm._v(" "+_vm._s(_vm.item)+" ")]),_c('v-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }